export default {
  key: "Succès",
  Things: "Des choses",
  "Upload Date": "Date de dépôt",
  Duration: "Durée",
  Features: "Fonctionnalités",
  "Edit Image": "Éditer l'image",
  Title: "Titre",
  Description: "La description",
  "New Image": "Nouvelle image",
  Image: "Image",
  Images: "Images",
  Tags: "Mots clés",
  "Save & close": "Sauvegarder et fermer",
  Type: "Taper",
  Edit: "Éditer",
  Delete: "Effacer",
  "Go back": "Retourner",
  "New item": "Nouvel article",
  Id: "Id",
  "Upload Image": "Télécharger une image",
  "Layouts Timeline": "Chronologie des mises en page",
  Date: "Date",
  "Back stage": "Arrière-scène",
  Front: "De face",
  items: "éléments",
  "Navigate: Things": "Naviguer : Choses",
  Orientation: "Orientation",
  back: "retour",
  front: "de face",
  gallery: "Galerie",
  preview: "Aperçu",
  New: "Nouveau",
  search: "chercher",
};
